import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { APIError, HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import { OrderFormPayload } from "../price-list/orderFormPayload"
import Email, { EmailDto } from "./Email"
import Proposal, { ProposalDto } from "./Proposal"



class ProposalService {
    static httpClient: HttpClient<Proposal, ProposalDto> = new HttpClient<Proposal, ProposalDto>(Proposal)
    static httpClientEmails : HttpClient<Email, EmailDto> = new HttpClient<Email, EmailDto>(Email)

    static async calculateTotal(
        proposalHash: string,
        chosenOptions: string[],
        itemQuantities: string[],
        selectedChoices: string[],
    ) {
        return await this.httpClient.post(`/proposals/${proposalHash}/calculate`,{
            chosenOptions: chosenOptions,
            itemQuantities: itemQuantities,
            selectedChoices: selectedChoices,
            simulate: true,
        })
    }

    static async requestPdf(hash: string): Promise<Proposal | HttpError> {
        const res = await this.httpClient.post(`/proposals/${hash}/pdf`,{})
        if (isError(res)) {
            return res as HttpError
        }
        return res as Proposal
    }

    static async getProposal(hash: string): Promise<Proposal | HttpError> {
        const res = await this.httpClient.get(`/proposals/${hash}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Proposal
    }

    static async get(hash: string): Promise<ProposalDto> {
        return AppContext.getApiClient().get(`/proposals/${hash}`)
    }

    static async getEmails(proposalId: string) {
        return AppContext.getApiClient().get(`/proposals/${proposalId}/emails`)
    }

    static async getProposalEmails(proposalId: string) : Promise<Email[] | HttpError> {
        const res = await this.httpClientEmails.get(`/proposals/${proposalId}/emails`)
        if (isError(res)) {
            return res as HttpError
        }
       
        if (Array.isArray(res)) {
            return res.map(email => new Email(email))
        }
        
        return [res]
    }

    static async createPaymentTransaction(hash: string, payload: OrderFormPayload): Promise<ProposalDto | APIError> {
        const res = AppContext.getApiClient().post(`/proposals/${hash}/payment-transactions`, payload)
        if (isError(res)) {
            return res as APIError
        }
        return res as ProposalDto
    }
}

export default ProposalService


// WEBPACK FOOTER //
// ./src/state/proposal/proposalService.ts